let yoNunca = [
    'Robé algo.',
    'Fuí multado.',
    'Fuí suspendido en el colegio.',
    'Estuve enamorado.',
    'Cambié una rueda.',
    'Vomité en alguien.',
    'Maté un animal.',
    'Estuve descontento con la cantidad de likes que tuvo una foto en Instagram.',
    'Subí un video a YouTube.',
    'Estuve en más de dos continentes.',
    'Tuve las mismas sábanas por tres semanas.',
    'Jugué al golf.',
    'Me olvidé la bolsita cuando saqué a pasear al perro y me hice el boludo cuando cagó.',
    'Falsifiqué una firma.',
    'Me electrocuté.',
    'Tapé el inodoro en casa ajena.',
    'Fui a una marcha/organización política.',
    'Viví una situación paranormal.',
    'Me hice una cirugía plástica.',
    'Comí los restos del plato de personas que no conocía en un local de comida.',
    'Disparé un arma de fuego.',
    'Gusté del hermano de un amigo.',
    'Estuve con alguien presente en el grupo.',
    'Fumé.',
    'Rompí algo en un ataque de ira.',
    'Estuve internado',
    'Sentí celos de un amigo.',
    'Estuve toda una noche jugando videojuegos.',
    'Estuve cuatro días sin bañarme.',
    'Creí en la reencarnación.',
    'Me fuí de un restaurante sin pagar.',
    'Tuve una experiencia cercana a la muerte.',
    'Usé el cepillo de dientes de otra persona.',
    'Terminé en la enfermería de un boliche.',
    'Intenté seguir una dieta vegana/vegetariana y fallé.',
    'Le saqué una foto al cago que me heché',
    'Doné sangre.',
    'Me desmayé en público',
    'Lloré en público.',
    'Me llevé más de cinco materias en el colegio.',
    'Hice pis en la calle.',
    'Dejé plantado a alguien.',
    'Hice un TikTok.',
    'Usé anabólicos/esteroides.',
    'Malviajé.',
    'Me fuí a las piñas en un boliche.',
    'Me robaron.',
    'Encaré a alguien en la calle.',
    'Me agarró el control de alcoholemia.',
    'Me tatué.',
    'Pensé en hacerme las tetas.',
    'Fumé un cigarrillo que encontré.',
    'Monté un caballo.',
    'Conocí a alguien famoso.',
    'Mentí negando que mentí.',
    'Me olvidé como llegué a casa la noche anterior.',
    'Lloré por alguien.',
    'Espié a alguien desde mi ventana.',
    'Corrí un colectivo.',
    'Pisé la nieve.',
    'Le corté a alguien por mensaje.',
    'Me arrepentí de haber salido con alguien.',
    'Fui a misa.',
    'Le escribí un poema a una pareja.',
    'Destapé una cerveza con los dientes.',
    'Mentí sobre mi edad.',
    'Manejé.',
    'Fuí picado por un aguaviva.',
    'Aparecí en la televisión.',
    'Fuí echado de un bar/boliche.',
    'Me quedé dormido en un bar/boliche.',
    'Cagué en un bar/boliche.',
    'Dormí en la calle.',
    'Fuí a un camping.',
    'Dije "te amo" siendo que no lo sentía.',
    'Lloré frente del espejo.',
    'Fuí picado por una abeja.',
    'Tuve un coma alcohólico.',
    'Mee en una pileta.',
    'Fuí mordido por un perro.',
    'Me cagué encima.',
    'Empecé un rumor falso.',
    'Vi Titanic.',
    'Fui al colegio/facultad/trabajo con resaca.',
    'Me denegaron la entrada a un bar/boliche.',
    'Estuve en un choque.',
    'Tiré sin querer el celular al inodoro.',
    'Me intoxiqué con una comida.',
    'Tuve brackets.',
    'Tuve dos citas en el mismo día.',
    'Trabajé drogado.',
    'Desayuné alcohol.',
    'Me hice pis encima.',
    'Me chamuyé a alguien que no conocía por Instagram.',
    'Photoshopee una foto mía.',
    'Hice un TikTok.',
    'Me subí a un helicoptero.',
    'Me quedé dormido en el trabajo.',
    'Me quedé dormido en el baño.',
    'Me rellené el corpiño.',
    'Me enamoré.',
    'Mee por la ventana.',
    'Mentí sobre mis sentimientos.',
    'Cambié un pañal.',
    'Anduve en bicicleta drogado o en pedo.',
    'Me puse en pedo solo.',
    'Vi todas las películas de Star Wars.',
    'Me hice el dormido cuando subió una embarazada al bondi.',
    'Voté a Macri.',
    'Fuí al colegio loco/a.',
    'Lloré en un transporte público.',
    'Me caí de la bicicleta.',
    'Fuí infiel.',
    'Hablé como Coscu.',
    'Perdí la conciencia de tanto tomar alcohol.',
    'Volví con mi pareja después de haber cortado.',
    'Revisé el celular de mi pareja sin su permiso.',
    'Entré a un sex-shop.',
    'Usé Tinder.',
    'Me fuí a las piñas en el boliche.',
    'Miré el papel después de ir al baño.',
    'Le hablé a mi ex en pedo.',
    'Ghosteé a alguien.',
]

export default yoNunca